import { render, staticRenderFns } from "./AccountForgotPassword.vue?vue&type=template&id=5a278030&scoped=true&lang=pug"
import script from "./AccountForgotPassword.vue?vue&type=script&lang=js"
export * from "./AccountForgotPassword.vue?vue&type=script&lang=js"
import style0 from "./AccountForgotPassword.vue?vue&type=style&index=0&id=5a278030&lang=scss"
import style1 from "./AccountForgotPassword.vue?vue&type=style&index=1&id=5a278030&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a278030",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a278030')) {
      api.createRecord('5a278030', component.options)
    } else {
      api.reload('5a278030', component.options)
    }
    module.hot.accept("./AccountForgotPassword.vue?vue&type=template&id=5a278030&scoped=true&lang=pug", function () {
      api.rerender('5a278030', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/account/AccountForgotPassword.vue"
export default component.exports